// StatsDashboard.jsx
import { useEffect, useState } from 'react';
import MonthlyVisitsChart from './Statistics/MonthlyVisitsChart';
import TopProductsChart from './Statistics/TopProductsChart';
import AllProductsTable from './Statistics/AllProductsTable';
import { getStats } from '../api/adminApi';

const StatsDashboard = () => {
  const [stats, setStats] = useState(null);
  const [period, setPeriod] = useState('month');

  useEffect(() => {
    const fetchStats = async () => {
      const data = await getStats();
      setStats(data);
    };
    fetchStats();
  }, [period]);

  if (!stats) return <div>Chargement...</div>;

  return (
    <div>
      <div style={{ marginBottom: 20 }}>
        <button onClick={() => setPeriod('month')} style={{ marginRight: 10 }}>Dernier mois</button>
        <button onClick={() => setPeriod('year')} style={{ marginRight: 10 }}>Dernière année</button>
        <button onClick={() => setPeriod('all')}>Tutti</button>
      </div>

      <MonthlyVisitsChart data={stats.monthlyVisits} />
      <TopProductsChart data={stats.topProducts} title={`Top 5 Produit (${period === 'month' ? 'mois' : period === 'year' ? 'année' : 'absolu'})`} />
      <AllProductsTable data={stats.allProducts} />
    </div>
  );
};

export default StatsDashboard;
